import produce from 'immer';

// TYPES
import { Types, ExcluirSigla } from './types';
import { ReducerActionRotaSP } from 'store/modules/types';

export const INITIAL_STATE: ExcluirSigla = {
	status: 0,
	data: null,
};

export default function excluirSiglaReducer(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ExcluirSigla {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_SIGLA_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.EXCLUIR_SIGLA_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.EXCLUIR_SIGLA_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_SIGLA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
